import { goToParentEffice } from "slices/efficeTreeSlice";

// let dispatch = null;
let getState = null;
import("Store").then((module) => {
  // dispatch = module.store.dispatch;
  getState = module.store.getState;
});

export function playKeys(e) {
  // check for safe keys
  if (unsafeKeysDisabled()) return;
  else if (isEscapeKey(e)) goToParentEffice();
}

export function startEfficeNavControls() {
  document.addEventListener("keydown", playKeys);
}
export function stopEfficeNavControls() {
  document.removeEventListener("keydown", playKeys);
}

const unsafeKeysDisabled = () =>
  getState().spaceMedia.spaceBoxActive ||
  getState().general.modalActive ||
  getState().general.inputBoxActive;

// const isLeftArrow = (e) => e.key === "ArrowLeft" || e.keyCode === 37;
export const isEscapeKey = (e) =>
  e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
